import './UploadDocs.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import FileUpload from '../atoms/FileUpload/FileUpload';
import FileUploadingInfo from '../atoms/FileUploadingInfo/FileUploadingInfo';
var UploadDocs = function UploadDocs(props) {
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "upload-docs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement(FileUpload, {
    title: props.fileUploadTitle,
    description: props.fileUploadDescription,
    dragNdropText: props.dragNdropText,
    uploadButtonLabel: props.uploadButtonLabel,
    onChange: props.onChange,
    onError: props.onError,
    maxSizeKb: props.maxSizeKb,
    maxSizeLabel: props.maxSizeLabel,
    supportedFormats: props.supportedFormats,
    supportedFormatsLabel: props.supportedFormatsLabel
  }), props.files && props.files.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "upload-docs__files-list"
  }, props.files.map(function (el, i) {
    return /*#__PURE__*/React.createElement(FileUploadingInfo, {
      key: el.id,
      byteDict: "$value$ byte",
      isUploaded: el.isUploaded,
      isLoading: el.isLoading,
      kbDict: "$value$ KB",
      filename: el.filename,
      percent: el.percent,
      size: el.size,
      successMessage: props.successMessage,
      onDelete: props.onDelete ? function () {
        return props.onDelete && props.onDelete(el.id);
      } : undefined,
      error: el.error
    });
  })))));
};
export default UploadDocs;
var StyledWrapper = function StyledWrapper(_ref) {
  var children = _ref.children,
    rtl = _ref.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c1pbdvkz";
var rtlStyles = "r1no258u";
var ltrStyles = "l1ssljic";